import { render, staticRenderFns } from "./Allocate Load.vue?vue&type=template&id=43fd07b5&"
import script from "./Allocate Load.vue?vue&type=script&lang=js&"
export * from "./Allocate Load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports